export default __webpack_public_path__ + "static/media/girl-mouth-mirror.f5897ff5.jpg";